import { chain, thirdWebClient } from "@/app/libs/thirdweb";
import { SPON, ThawingPool } from "@/contracts/addresses";
import {
  getContract,
  prepareContractCall,
  sendAndConfirmTransaction,
} from "thirdweb";
import { Account } from "thirdweb/wallets";

export async function depositToPool(
  amount: bigint,
  to: string,
  account: Account
) {
  const contractAddress = ThawingPool;
  const tokenAddress = SPON;
  try {
    const tokenContract = getContract({
      client: thirdWebClient,
      chain,
      address: tokenAddress,
    });

    const poolContract = getContract({
      client: thirdWebClient,
      chain,
      address: contractAddress,
    });

    const approveRequest = await prepareContractCall({
      contract: tokenContract,
      method: {
        inputs: [
          {
            internalType: "address",
            name: "spender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
        ],
        name: "approve",
        outputs: [
          {
            internalType: "bool",
            name: "",
            type: "bool",
          },
        ],
        stateMutability: "nonpayable",
        type: "function",
      },
      params: [contractAddress, amount],
    });

    const approveTx = await sendAndConfirmTransaction({
      transaction: approveRequest,
      account,
    });
    console.log(`Token approval successful: ${approveTx.transactionHash}`);

    const depositRequest = await prepareContractCall({
      contract: poolContract,
      method: {
        type: "function",
        name: "deposit",
        inputs: [
          { name: "_amount", type: "uint256", internalType: "uint256" },
          { name: "_to", type: "address", internalType: "address" },
        ],
        outputs: [],
        stateMutability: "nonpayable",
      },
      params: [amount, to],
    });

    const depositTx = await sendAndConfirmTransaction({
      transaction: depositRequest,
      account,
    });
    console.log(`Deposit successful: ${depositTx.transactionHash}`);
    return depositTx.transactionHash;
  } catch (error) {
    console.error("Error depositing to pool:", error);
    throw error;
  }
}
